import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37f962da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { id: "about2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wenhao" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wenhaoTxt" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "txt1" }, "通过该患者的临床表现及病史，"),
    /*#__PURE__*/_createElementVNode("div", { class: "txt1" }, "符合以下哪些表现？(多选)")
  ])
], -1))
const _hoisted_4 = { class: "zljg" }
const _hoisted_5 = { class: "radioBox" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "bottomBox" }
const _hoisted_11 = {
  key: 0,
  class: "swperList"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ip" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      style: {"top":"50%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_checkbox_group, {
              modelValue: $data.checkVal,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.checkVal) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_van_checkbox, {
                    key: "1",
                    value: "1",
                    modelValue: $setup.checkedd,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.checkedd) = $event)),
                    name: "1"
                  }, {
                    icon: _withCtx((props) => [
                      _createElementVNode("img", {
                        class: "img-icon",
                        src: props.checked ? $data.activeIcon : $data.inactiveIcon
                      }, null, 8, _hoisted_6)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("A.病程超过6个月的对称性湿疹 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_van_checkbox, {
                    key: "2",
                    value: "2",
                    modelValue: $setup.checkedd,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.checkedd) = $event)),
                    name: "2"
                  }, {
                    icon: _withCtx((props) => [
                      _createElementVNode("img", {
                        class: "img-icon",
                        src: props.checked ? $data.activeIcon : $data.inactiveIcon
                      }, null, 8, _hoisted_7)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("B.特应性个人史和/或家族史 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_van_checkbox, {
                    key: "3",
                    value: "3",
                    modelValue: $setup.checkedd,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.checkedd) = $event)),
                    name: "3"
                  }, {
                    icon: _withCtx((props) => [
                      _createElementVNode("img", {
                        class: "img-icon",
                        src: props.checked ? $data.activeIcon : $data.inactiveIcon
                      }, null, 8, _hoisted_8)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("C.血清总IgE升高和/或外周血嗜酸性粒 细胞升高和/或过敏原特异性 IgE 阳性 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_van_checkbox, {
                    key: "3",
                    value: "4",
                    modelValue: $setup.checkedd,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.checkedd) = $event)),
                    name: "4"
                  }, {
                    icon: _withCtx((props) => [
                      _createElementVNode("img", {
                        class: "img-icon",
                        src: props.checked ? $data.activeIcon : $data.inactiveIcon
                      }, null, 8, _hoisted_9)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("D.细菌感染迹象 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_van_image, {
              onClick: $options.biaozhun,
              width: "6.8667rem",
              height: "1.1467rem",
              src: require('../assets/chakan.png')
            }, null, 8, ["onClick", "src"])
          ]),
          ($props.postaimqus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_van_image, {
                  width: "5.2667rem",
                  height: "4.8rem",
                  src: require('../assets/gongge.jpg')
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _hoisted_12,
    _hoisted_13,
    _createVNode(_component_toNav, { menu: 2 })
  ], 64))
}